import React, { ReactNode } from 'react';

import { Layout } from 'app/pages/NewAccount/layouts';
import { ACCOUNT_MNG_MENU } from 'app/pages/NewAccount/layouts/AccountManager';
import StyledButton from 'app/components/StyledButton';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'app/pages/App/slice/selectors';

const RefundLayout = ({
  children,
  title,
  useActionBlock,
  onBack,
  onNext,
  disabledNextBtn,
  disabledBackBtn,
  isLoadingBack,
  isLoadingNext,
  menuActive = ACCOUNT_MNG_MENU.CHECK_TICKET,
}: {
  children: ReactNode;
  title: string | ReactNode;
  useActionBlock?: boolean;
  onBack?: () => void;
  onNext?: () => void;
  disabledBackBtn?: boolean;
  disabledNextBtn?: boolean;
  isLoadingBack?: boolean;
  isLoadingNext?: boolean;
  menuActive?: ACCOUNT_MNG_MENU;
}) => {
  const translations = useSelector(selectTranslations);
  return (
    <Layout title={title} menuActive={menuActive}>
      {children}
      <div>
        {useActionBlock ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ marginTop: 36 }}
          >
            <StyledButton
              textColor="#808080"
              bgColor="transparent"
              border="solid 1px #808080"
              onClick={onBack}
              disabled={disabledBackBtn}
            >
              {isLoadingBack
                ? 'Loading...'
                : translations?.['b2b.txt.back'] ?? ''}
            </StyledButton>
            <StyledButton
              textColor="#ffffff"
              style={{ marginLeft: 18 }}
              onClick={onNext}
              border={
                disabledNextBtn ? 'solid 1px #808080' : 'solid 0px #808080'
              }
              disabled={disabledNextBtn}
            >
              {isLoadingNext
                ? 'Loading...'
                : translations?.['b2b.txt.continue'] ?? ''}
            </StyledButton>
          </div>
        ) : null}
      </div>
    </Layout>
  );
};

export default RefundLayout;
